import React from 'react';
import PropTypes from 'prop-types';
import { useStore, useDispatch } from 'react-redux';
import styled from 'styled-components';
// import { convertStringToElements } from '@vds/html-parsers';
import { Body } from '@vds/typography';
import OverlayModal from '../common/overlayModal';
import * as actionTypes from '../@Redux/actionTypes';
import { handleDisclosurePerks, handleDuplicatePerks } from '../common/helpers';
// import { isJointTransactionFlow } from '../../../components/common/Helpers';

const WrapperBody = styled.div`
  margin-top: 15px;
`;
const PerkConflictModal = () => {
  const state = useStore().getState();
  const dispatch = useDispatch();
  const perkConflictOverlay = state?.progressivePlans?.perkConflictOverlay;
  const planData = state?.progressivePlans?.progressivePlanAPiResponse;
  const availablePerks =
    planData?.data?.lineLevelPlans?.lines?.length && planData?.data?.lineLevelPlans?.lines[0]?.availablePerks
      ? planData?.data?.lineLevelPlans?.lines[0]?.availablePerks
      : [];
  const selectedPerks = state?.progressivePlans?.selectedPlanInfo?.selectedPerks ? state?.progressivePlans?.selectedPlanInfo?.selectedPerks : [];
  if (!perkConflictOverlay?.switchId) return;
  const { appleConflictCq, perkStaticContent } = state?.plansReferenceData?.output || {};
  const { header, content = [], buttonData } = appleConflictCq?.[perkConflictOverlay.switchId] || {};
  const splitSwitch = perkConflictOverlay.switchId?.split?.('_TO_');
  const previousSelected = selectedPerks.find((item) => item.spoId === splitSwitch?.[0]);
  const currentSelected = selectedPerks.find((item) => item.spoId === splitSwitch?.[1]);
  const viewedDuplicatePerks = new Set();
  selectedPerks.map((perk) => viewedDuplicatePerks.add(perk.spoId));

  const updateToggle = (data) => {
    dispatch({ type: actionTypes.UPDATE_SELECT_DATA_PERK, payload: data });
  };
  const handleDuplicateAndDisclosure = (selectSpoID) => {
    const noDuplicatePerk = handleDuplicatePerks(state, true, selectSpoID, viewedDuplicatePerks, dispatch);
    if (noDuplicatePerk) {
      handleDisclosurePerks(perkStaticContent, selectSpoID, state, true, dispatch);
    }
  };
  const clickPerks = (item) => {
    // console.log('selectedItem', item);
    if (item.noActionRequired) {
      // same option selected
      updateToggle({ perkInfo: currentSelected, toggleOn: false });
    } else {
      //   const existingSpoID = availablePerks.find((item1) => item1.spoId === item.existingSpoId);
      const selectSpoID = availablePerks.find((item1) => item1.spoId === item.spoId);
      // reset previous selected conflicts starts
      updateToggle({ perkInfo: previousSelected, toggleOn: false });
      updateToggle({ perkInfo: currentSelected, toggleOn: false });
      // reset previous selected conflicts end
      // enable chosen spoId CTA starts
      setTimeout(() => {
        handleDuplicateAndDisclosure(selectSpoID);
        updateToggle({ perkInfo: selectSpoID, toggleOn: true });
      });
      // enable chosen spoId CTA ends
    }
    dispatch({
      type: actionTypes.PERKS_CONFLICT_OVERLAY,
      response: {
        ...perkConflictOverlay,
        switchId: null,
        show: false,
      },
    });
  };
  const modalData = {
    title: header,
    description: content.map((item) => (
      <WrapperBody>
        <Body size="large">{item}</Body>
      </WrapperBody>
    )),
    buttonDataGroup: buttonData?.map((item) => {
      const item1 = item;
      item1.onClick = () => clickPerks(item);
      return item1;
    }),
    onModalCloseHandler: () => {
      dispatch({
        type: actionTypes.PERKS_CONFLICT_OVERLAY,
        response: {
          ...perkConflictOverlay,
          show: false,
        },
      });
      // remove previous and select current
      updateToggle({ perkInfo: previousSelected, toggleOn: false });
      updateToggle({ perkInfo: currentSelected, toggleOn: true });
      handleDuplicateAndDisclosure(currentSelected);
    },
    isOpened: perkConflictOverlay?.show,
  };

  return <OverlayModal {...modalData} />;
};

PerkConflictModal.propTypes = {
  modalArrgs: PropTypes.object,
};

export default PerkConflictModal;
